import request from '@/plugins/request';
let Api = {};
const sys = '/platform/'
const pre = 'dicttree';
// 列表
Api.tableList = function (data) {
    return request({
        url: `${sys}${pre}_page`,
        method: 'get',
        params: data
    });
}
// 查看
Api.getTableById = function (id) {
    return request({
        url: `${sys}${pre}_id/${id}`,
        method: 'get'
    });
}
// 新增
Api.addTable = function (data) {
    return request({
        url: `${sys}${pre}`,
        method: 'post',
        data
    });
}
// 编辑
Api.editTable = function (data) {
    return request({
        url: `${sys}${pre}`,
        method: 'patch',
        data
    });
}
// 删除
Api.deleteTable = function (id) {
    return request({
        url: `${sys}${pre}/${id}`,
        method: 'delete'
    });
}
// 批量删除
Api.deleteTableAll = function (ids) {
    return request({
        url: `${sys}${pre}_ids/${ids}`,
        method: 'delete'
    });
}

export default Api



// WEBPACK FOOTER //
// ./src/api/platform/dicttree.js